/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { identity } from '@gh/core-data';

export const EtagDictionaryMapper = identity();
